module.exports = __webpack_public_path__ + "img/mingyu.98607ffd.png";